const AB_MULTI_BUY_KEY = 'applianceBarnMultiBuyQuote';

function readABMultiBuyCount() {
  try {
    const raw = localStorage.getItem(AB_MULTI_BUY_KEY);
    if (!raw) return 0;
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.length;
    if (Array.isArray(parsed?.items)) return parsed.items.length;
    if (parsed && typeof parsed === 'object') return Object.keys(parsed).length;
  } catch (error) {
    console.warn('Unable to read multi-buy basket', error);
  }
  return 0;
}

function updateABMultiBuyCount() {
  const count = readABMultiBuyCount();
  document.querySelectorAll('[data-ab-multibuy-count]').forEach((element) => {
    element.textContent = String(count);
    element.hidden = count < 1;
  });
}

document.addEventListener('DOMContentLoaded', updateABMultiBuyCount);
document.addEventListener('multi-buy-quote:updated', updateABMultiBuyCount);
window.addEventListener('storage', (event) => {
  if (event.key === AB_MULTI_BUY_KEY) updateABMultiBuyCount();
});
